(function () {
  const addToCartButtons = document.querySelectorAll('.nb-model-comparison__btn[js-add-to-cart]');

  addToCartButtons.forEach((button) => {
    button.addEventListener('click', async function (e) {
      e.preventDefault();

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      this.disabled = true;
      this.classList.add('loading');
      const originalText = this.textContent;
      this.textContent = 'Adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId),
                quantity: 1,
              },
            ],
            sections: 'cart-drawer,cart-icon-bubble',
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart) {
          if (cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        }

        this.textContent = 'Added!';
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
          this.classList.remove('loading');
        }, 1500);
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.textContent = 'Error';
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
          this.classList.remove('loading');
        }, 1500);
      }
    });
  });
})();
